let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("kqcH1")).then(() => parcelRequire('RiK2l'));